<template>
    <div>
        <template v-if="loan_amount_ledger === true">
            <div>
                <div class="corporate-main">
                  <h1>Lending Ledger</h1>
                <br>
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label class="label block-label"> From Date </label>
                            <datepicker name="from_date" v-model="from_date" input-class="datepicker" :bootstrap-styling="true" placeholder="From Date"></datepicker>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label class="label block-label"> To Date </label>
                            <datepicker name="to_date" v-model="to_date" input-class="datepicker" :bootstrap-styling="true" placeholder="To Date"></datepicker>
                        </div>
                    </div>
                    <div class="col-md-4" v-if="companies.length>1">
                        <div class="form-group">
                            <label>Companies</label>
                            <select v-model="selectedcompanies" data-live-search="true" multiple name="selectedcompanies" id="selectedcompanies" class="selectpicker custom-select2 form-control">
                                    <option v-for="companyloop in companies" v-bind:value="companyloop.id" v-bind:key="companyloop.id">
                                        {{ companyloop.name }}
                                    </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group align-right">
                            <br>
                            <button @click="getLoanAmountLedger" v-if="!showBtn"  class="btn btn-primary">Submit</button>
                            <button @click="filterTable" v-if="showBtn"  class="btn btn-primary">Submit</button>
                        </div>
                    </div>
                </div>
                    <div class="corporate-head pb-3 clearfix">
                        <h3 class="transaction-history-head float-left"> Lending Ledger</h3>
                        <div class="dt-buttons" id="buttons">
                            <a _target="_blank" class="dt-button buttons-excel buttons-html5" tabindex="0" aria-controls="newTab"   @click="downloadExcel();" ><span><span class="fa fa-file-excel-o"></span>Export</span></a>
                            <a _target="_blank" class="dt-button buttons-excel buttons-html5" tabindex="0" aria-controls="newTab"   @click="printTransactions();" ><span><span class="fa fa-file-excel-o"></span>Print</span></a>
                        </div>
                        <!-- <div class="searching float-right">
                            <input id="custom_search" type="text" class="form-control search" autocomplete="off" />
                        </div> -->
                    </div>
                    <table id="dt-table" class="table" style="width:100%">
                        <thead>
                            <tr>
                              <th>Date</th>
                              <th>Company AC#</th>
                              <th>TXN ID</th>
                              <th>Transaction Type</th>
                              <th>Description</th>
                              <th>Debit</th>
                              <th>Credit</th>
                              <th>Running Balance</th>
                              <th>{{(check!='SUPERADMIN')?'Branch':'Company Name'}}</th>
                            </tr>
                        </thead>
                    </table>
                </div>
            </div>
        </template>
        <template v-else-if="loan_amount_ledger === null"><preLoader></preLoader></template>
        <template v-else-if="loan_amount_ledger === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    var dtTable = null;
    export default {
        data() {
            return {
                from_date : '',
                to_date : '',
                ledger : [],
                account_balance: null,
                showBtn: false,
              loan_amount_ledger: null,
                selectedcompanies:[],
                companies:[{'id':1,"name":"ALI"}],
                check:'',
                dtTable:''
            };
        },
        methods: {
            getCompanies(){
                let self=this;
                axios.get('/api/getCompaniesLeadger')
                        .then((response) => {
                           self.companies=response.data.companies;
                           self.check=response.data.check
      					  self.getLoanAmountLedger();
 

                        setTimeout(function(){  $("#selectedcompanies").selectpicker('refresh'); }, 0);
 
                        }).catch(err => {
                            this.$Progress.fail();
                            this.showAlertBox('error','There is some problem');
                        });
            },
            filterTable(){
                this.$Progress.start();
                this.dtTable.draw();
                this.$Progress.finish();
            },
            downloadExcel: function(id){
                this.$Progress.start();
                let that=this
                var formData = {
                    'from_date': moment(this.from_date).format('YYYY-MM-DD'),
                    'to_date': moment(this.to_date).format('YYYY-MM-DD'),
                    'company':that.selectedcompanies

                }
                axios.post('/api/downloadLoanAmountLedgerExcel',formData,{
                    responseType: 'blob'
                })
                .then((response) => {
                    console.log(response);
                    if(response.status == 200){
                        this.$Progress.finish();
                        const url = URL.createObjectURL(new Blob([response.data], {
                            type: 'application/vnd.ms-excel'
                        }))

                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download', 'loan_amount_ledger.xlsx')
                        document.body.appendChild(link)
                        link.click()
                        this.$Progress.finish();
                    }else{
                        this.showAlertBox('error','There is some problem');
                    }

                }).catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                });
            },
            printTransactions: function(id){
                this.$Progress.start();
                 let that=this;
                var formData = {
                    'from_date': moment(this.from_date).format('YYYY-MM-DD'),
                    'to_date': moment(this.to_date).format('YYYY-MM-DD'),
                    'company':that.selectedcompanies
                }
                axios.post('/api/printLoanAmountLedgerFinance',formData)
                .then((response) => {
                    if(response.status == 200){
                        this.$Progress.finish();
                        var mywindow = window.open('', 'PRINT', 'height=400,width=600');
                        // mywindow.document.write('<html><head><title>' + document.title  + '</title>');
                        // mywindow.document.write('</head><body >');
                        // mywindow.document.write('<h1>' + document.title  + '</h1>');
                        mywindow.document.write(response.data);
                        // mywindow.document.write('</body></html>');
                        mywindow.document.close(); // necessary for IE >= 10
                        mywindow.focus(); // necessary for IE >= 10*/
                        mywindow.print();
                        // mywindow.close();
                        return true;
                    }else{
                        this.showAlertBox('error','There is some problem');
                    }

                }).catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                });
            },

            getLoanAmountLedger: function(){
                this.$Progress.start();
                let self = this;
                self.dtTable = $('#dt-table').DataTable({
                    sDom: '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    serverSide: true,
                    pageLength: 30,
                    searching :true,
                    buttons: [],
                    ajax: {
                        "url": "api/loanAmountLedger",
                        "data": function (d) {
                            d.from_date = moment(self.from_date).format('YYYY-MM-DD');
                            d.to_date = moment(self.to_date).format('YYYY-MM-DD');
                            d.company = self.selectedcompanies;
                        },
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                    },
                    deferRender: true,
                    columns: [
                      {render: function(data,type,full){
                          if(full.created_at != null){
                            return moment(full.created_at).format('YYYY-MM-DD');
                          }else{
                            return "---";
                          }
                        }},
                      {render: function(data,type,full){
                          if(full.walletID != null){
                            return full.walletID;
                          }else{
                            return "---";
                          }
                        }},
                      {render: function(data,type,full){
                          if(full.transaction_id != null){
                            return full.transaction_id;
                          }else{
                            return "---";
                          }
                        }},
                    {render: function(data,type,full){
                        if(full.type != null){
                            return full.type;
                        }else{
                            return "---";
                        }
                    }},
                      {render: function(data,type,full){
                          if(full.text != null){
                            return full.text;
                          }else{
                            return "---";
                          }
                        }},
                      {render: function(data,type,full){
                          if(full.type === 'DEBIT'){
                            return full.amount;
                          }else{
                            return "--";
                          }
                        }},
                      {render: function(data,type,full){
                          if(full.type === 'CREDIT'){
                            return full.amount;
                          }else{
                            return "--";
                          }
                        }
                        },
                        {'data':'running_loan_balance'},
                         {render: function(data,type,full){
                        if(full.name != null){
                            return full.name;
                        }else{
                            return "---";
                        }
                    }}               
                       ],
                     "drawCallback": function(settings) {
                         if(self.check !='SUPERADMIN'){
                            var columnReason2 = self.dtTable.column(1).visible(false);
                          }
                         },
                    "order": [[ 0, "desc" ]],
                    "initComplete": (res) => {
                        self.hasPer = true;
                        self.showBtn = true;
                        setTimeout(function(){
                            $('select.selectpicker').selectpicker();
                        },300);
                        self.$Progress.finish();
                    }
                });

                // $('#custom_search').on( 'keyup', function () {
                //     dtTable.fnFilter(this.value);
                // });
            }

        },
        mounted() {
            let self=this;
     
			this.can('loan_amount_ledger|shared_companies_ledger').then(result => {
			  if (result.loan_amount_ledger || result.shared_companies_ledger ) {
                    this.loan_amount_ledger = true;
                }
                this.account_balance = result.vr_balance;
            }).then(result => {
                if(this.loan_amount_ledger == true){
                     self.getCompanies();

                   $(document).ready(function(){
                             $('#selectedcompanies').selectpicker();

                    })
                }
            });

        },
    }
</script>
